import { ADD_SUCCESS_MESSAGE, REMOVE_SUCCESS_MESSAGE } from "./actions";

const initialState = null;

export function successReducer(state = initialState, action) {
	switch (action.type) {
		case ADD_SUCCESS_MESSAGE:
			return action.data;
		case REMOVE_SUCCESS_MESSAGE:
			return null;
		default:
			return state;
	}
}
